/// <amd-module name="Environments/ProviderCreateDetails/Kubernetes/Actions/KubernetesResourceActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { EnvironmentResourceReference } from "DistributedTask/Client/Contracts/TaskAgent";

export interface IGenericResourceValidationResult {
    type: "Success" | "Warn" | "Error" | "None";
    message: string;
}

export class KubernetesResourceActions extends ActionsHubBase {

    public static getKey(): string {
        return "kubernetes-resource-actions";
    }

    public initialize(instanceId?: string) {
        this._addResource = new Action<EnvironmentResourceReference>();
        this._updateCreationState = new Action<"InProgress" | "Succeeded" | "Failed" | "NotStarted">();
        this._genericValidationResult = new Action<IGenericResourceValidationResult>();
    }

    public get addKubernetesResource(): Action<EnvironmentResourceReference> {
        return this._addResource;
    }

    public get updateCreationState(): Action<"InProgress" | "Succeeded" | "Failed" | "NotStarted"> {
        return this._updateCreationState;
    }

    public get genericValidationResult(): Action<IGenericResourceValidationResult> {
        return this._genericValidationResult;
    }

    private _addResource: Action<EnvironmentResourceReference>;
    private _updateCreationState: Action<"InProgress" | "Succeeded" | "Failed" | "NotStarted">;
    private _genericValidationResult: Action<IGenericResourceValidationResult>;
}
